<template>
  <span
    ref="ci"
    class="cloud-image"
    :style="style">
    <div
      v-if="loading && !err"
      class="loader">
      <f7-preloader />
    </div>
    <img
      ref="img"
      v-show="!background"
      v-if="url && !err"
      crossorigin="anonymous"
      :src="url"
      @load="load"
      @error="err = true" />
  </span>
</template>

<script>
import moment from 'moment'
import inViewport from 'in-viewport'
import { mapGetters } from 'vuex'
import { cloudImage } from '@/services/atlastories'
export default {
  name: 'CloudImage',
  props: {
    src: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 320
    },
    height: {
      type: Number
    },
    crop: {
      type: Boolean,
      default: true
    },
    fluid: {
      type: Boolean
    },
    rounded: {
      type: Number,
      default: 0
    },
    background: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      local: false,
      url: null,
      err: false,
      blob: null
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    days () {
      return this.setting('cache')
    },
    style () {
      let s = {}
      s.width = this.fluid ? '100%' : this.width + 'px'
      if (this.height) s.height = this.height + 'px'
      if (this.fluid) s.height = 'auto'
      if (this.rounded) s.borderRadius = this.rounded + 'px'
      if (this.blob) s.backgroundImage = 'url(' + this.blob + ')'
      return s
    },
    filename () {
      return this.src.split('/').pop().split('?').shift()
    },
    cloudurl () {
      return cloudImage(this.src, this.width, this.height, this.crop)
    }
  },
  methods: {
    load () {
      if (!this.local && this.$refs.img) {
        const canvas = document.createElement('CANVAS')
        const ctx = canvas.getContext('2d')
        canvas.height = this.$refs.img.naturalHeight
        canvas.width = this.$refs.img.naturalWidth
        ctx.drawImage(this.$refs.img, 0, 0)
        // save to dexie
        const ts = moment().unix()
        canvas.toBlob(blob => {
          const url = URL.createObjectURL(blob)
          this.$emit('blob', url)
          this.$db.images.put({ url: this.cloudurl, ts, blob })
          this.loading = false
          if (this.background) this.blob = url
        })
      }
    },
    lazy () {
      inViewport(this.$refs.ci, () => {
        this.url = this.cloudurl
        this.loading = true
      })
    },
    cache () {
      // dexie
      this.$db.images.get(this.src).then(res => {
        if (!res) this.lazy()
        else {
          this.local = true
          this.url = URL.createObjectURL(res.blob)
          this.loading = false
          if (this.background) this.blob = this.url
        }
      })
    }
  },
  mounted () {
    this.cache()
  }
}
</script>

<style lang="scss">
.cloud-image {
  display: inline-block;
  position: relative;
  line-height: 0;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  background-color: #e6e6e6;
  background-image: url('../../assets/images/img-placeholder.svg');
  background-position: center;
  background-size: cover;
  img {
    width: 100%;
    height: auto;
  }
  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
